<template>
    <div class="form">
        <Form ref="info" :model="info" :label-width="100">
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="客户姓名：" prop="cusName">{{
                        info.cusName
                    }}</FormItem>
                </Col>

                <Col span="12">
                    <FormItem label="客户手机号：" prop="cusMobile">{{
                        info.cusMobile
                    }}</FormItem>
                </Col>
            </Row>
        </Form>
        <table-tool-bar
            v-if="
                this.cusStatus == 1 ||
                this.cusStatus == 2 ||
                this.cusStatus == undefined
            "
        >
            <Button
                v-if="$can('add')"
                :class="preCls + 'button-margin'"
                :disabled="loading"
                type="primary"
                @click="onClickAdd"
                >新增</Button
            >
        </table-tool-bar>
        <!-- 弹出层 -->
        <smart-modal
            v-model="modal.showCustomer"
            title="新增跟进"
            :width="800"
            :height="400"
            :maskClosable="false"
            @close-by-confirm="fetch"
        >
            <c-info-hfjl-form
                v-if="modal.showCustomer"
                :cusId="info.id"
                :id="curTrackId"
                :cusName="info.cusName"
                :cusMobile="info.cusMobile"
            ></c-info-hfjl-form>
        </smart-modal>
        <!-- 表格 -->
        <Table
            ref="mt"
            :columns="columns"
            :data="page.list"
            :loading="loading"
            height="330"
        >
            <template slot-scope="{ row }" slot="status">
                <tag-status
                    :text="row.cusStatusText"
                    :color="row.cusStatusColor"
                    :background="row.cusStatusBgc"
                    circle
                />
            </template>
            <template v-slot:action="{ row }">
                <PoptipButton
                    type="default"
                    title="您确定删除这条记录吗？"
                    text="删除"
                    style="margin-right: 5px"
                    placement="top"
                    size="small"
                    transfer
                    :ok="() => doTrackDel(row)"
                ></PoptipButton>
            </template>
            <!-- 操作列-->
        </Table>
        <table-pager
            transfer
            :total.sync="page.totalCount"
            :pageSize.sync="filter.pageSize"
            :pageNo.sync="filter.page"
            @change="fetch"
        ></table-pager>
    </div>
</template>
<script>
import Dict from "_u/dict";
import { tel } from "_u/validate";
import dayjs from "dayjs";
import { ymdL } from "_u/helper";

import CInfoHfjlForm from "./c-info-hfjl-form";
import TagStatus from "_vc/tag-status";

import { cInfoAdd, cTrackList, cTrackDel } from "@/api/customer";

export default {
    name: "c-info-hfjl-list",

    props: {
        id: {
            type: [String, Number],
        },
        cusName: {
            type: String,
        },
        cusMobile: {
            type: String,
        },
        cusStatus: {
            type: [String, Number],
        },
    },

    components: {
        CInfoHfjlForm,
        TagStatus,
    },

    inject: {
        $modal: {
            default: null,
        },
    },

    data() {
        return {
            loading: false,
            modal: {
                showCustomer: false,
            },
            info: {
                id: this.id,
                cusName: this.cusName, //客户名称
                cusMobile: this.cusMobile, // 客户手机号码
            },

            dict: {
                cusStatus: Dict.NULL,
            },
            filter: {
                cusId: this.id,
                page: 1,
                pageSize: 20,
            },
            curTrackId: "",
            page: {
                totalCount: 0,
                list: [],
            },
        };
    },

    computed: {
        columns() {
            return [
                {
                    key: "trackTime",
                    title: "时间",
                    align: "center",
                    minWidth: 150,
                    tooltip: true,
                },
                {
                    key: "cusStatus",
                    title: "客户状态",
                    align: "center",
                    minWidth: 160,
                    slot: "status",
                },
                {
                    key: "trackStatus",
                    title: "跟进情况",
                    align: "center",
                    minWidth: 90,
                },
                {
                    key: "content",
                    title: "跟进记录",
                    align: "left",
                    minWidth: 120,
                    tooltip: true,
                },
                {
                    key: "trackUser",
                    title: "跟进人",
                    align: "center",
                    minWidth: 80,
                },
                {
                    key: "action",
                    title: "操作",
                    align: "center",
                    width: 120,
                    fixed: "right",
                    slot: "action",
                },
            ];
        },
    },
    methods: {
        onClickAdd() {
            this.modal.showCustomer = true;
        },

        fetch() {
            this.loading = true;
            Promise.all([Dict.get(["cus_status"]), cTrackList(this.filter)])
                .then((args) => {
                    let [dict, track] = args;
                    Object.keys(this.dict).forEach((key) => {
                        this.dict[key] = dict[key];
                    });
                    this.setData(track.data);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        setData(data) {
            var dataList = data.page.list;
            const cusStatusDict = this.dict.cusStatus;
            dataList.forEach((v) => {
                v.trackTime = ymdL(v.trackTime);
                const status = cusStatusDict.get(v.cusStatus);
                if (status) {
                    status.remark = JSON.parse(status.remark);
                    v.cusStatusText = status.text;
                    v.cusStatusColor = status.remark.color;
                    v.cusStatusBgc = status.remark.background;
                } else {
                    v.cusStatusText = "";
                }
            });
            this.page.list = data.page.list;
            this.page.totalCount = parseInt(data.page.totalCount);
        },
        doTrackDel(row) {
            this.loading = true;
            cTrackDel(row.id)
                .then(() => {
                    this.$Message.success(this.$t("tips.delete.success"));
                })
                .then(() => {
                    return cTrackList(this.filter);
                })
                .then((args) => {
                    this.setData(args.data);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },

    created() {
        this.fetch();
    },

    mounted() {
        // var $info = this.$refs.info;
        // // 按钮配置
        // var btns = [{ type: "default", text: "关闭", name: "cancel" }];
        // this.$modal.updateBtns(btns);
        // this.$modal.beforeEnter((next) => {
        //     Promise.all([this.fetch(), Dict.get(["cus_status"])])
        //         .then((args) => {
        //             var [res, dictGroup] = args;
        //             Object.keys(this.dict).forEach((name) => {
        //                 this.dict[name] = dictGroup[name];
        //             });
        //             const cusStatusDict = this.dict.cusStatus;
        //             res.data.page.list.forEach((v) => {
        //                 v.trackTime = ymdL(v.trackTime);
        //                 const status = cusStatusDict.get(v.cusStatus);
        //                 if (status) {
        //                     status.remark = JSON.parse(status.remark);
        //                     v.cusStatusText = status.text;
        //                     v.cusStatusColor = status.remark.color;
        //                     v.cusStatusBgc = status.remark.background;
        //                 } else {
        //                     v.cusStatusText = "";
        //                 }
        //             });
        //             this.page.list = res.data.page.list;
        //             this.page.totalCount = parseInt(res.data.page.totalCount);
        //             console.log(this.cusStatus);
        //         })
        //         .finally(() => {
        //             this.loading = false;
        //             next();
        //         });
        // });
    },
};
</script>
<style lang="less" scoped></style>
